export const THEMES = [
    'default',
    'modern-dark',
    'blue',
    'green',
    'twilight',
    'game',
    'modern-gradient',
    'cosmos',
];
export const DEFAULT_THEME = 'modern-dark';
//# sourceMappingURL=themes.js.map